import { appAutoLoginAPI, appAutoLoginRegAPI, globalAutoLogin } from "../api/accountAPI";
import { useCallback } from "react";
import { useHistory } from 'react-router-dom';
import { TYPE } from "../constant";
import { getAppId } from "../utils/utilityEtc";
import { useUserInfo } from ".";
import useLoading from "./useLoading";

export default function useAppAutoLogin() {
  const history = useHistory();
  const { info } = useUserInfo();
  const { setLoading, clearLoading } = useLoading();

  const appAutoLoginRegAPICall = useCallback(async (mbrId, entryType) => {
    const appId = await getAppId();
// console.log("##### appId: ", appId);
    if (!appId || !mbrId) return;
    await appAutoLoginRegAPI({
      mbrId,
      appId,
      chnCd: entryType
    });
  }, [info]);

  // 교문 탈패드 auto 로그인
  const appAutoLoginAPICall = useCallback(async () => {
// console.log("##### appId: ", appId);
    setLoading({ isShowSpinner: true, spinnerType: '1' });
    const appId = await getAppId();
    if (!appId) return;

    const accessToken = localStorage.getItem('access.token');

    const resp = await appAutoLoginAPI({
      appId,
      accessToken,
      chnCd: TYPE.CHANNEL.GM_APP,
    });
    return resp;
  }, []);

  // 글로벌 auto 로그인
  const appGlobalAutoLoginAPICall = useCallback(async (purchsYn) => {
    const appId = await getAppId();
    if (!appId) return;
    setLoading({ isShowSpinner: true, spinnerType: '1' });
    const accessToken = localStorage.getItem('access.token');

    const resp = await globalAutoLogin({
      appId,
      accessToken,
      chnCd: TYPE.CHANNEL.GLOBAL01,
      // frPurchsYn : purchsYn,
      // productId : productId
    });
    
    if (resp?.code === 'S001006') {
      history.push('/login');
    }
    // clearLoading();
    return resp;
  }, []);

  return { appAutoLoginRegAPICall, appAutoLoginAPICall, appGlobalAutoLoginAPICall }
}